/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react'

import UIButton from '../../components/UI/UIButton'

import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'

import { CircularProgressbar } from 'react-circular-progressbar'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import { useQuery } from 'react-query'
import {
  getSafeguardingCategoriesForSCR,
  getTraningCategoriesForSCR,
  User,
} from './apiCalls'
import { Icon } from '../../components/Icon'
import { lastStr } from '../policy/utils'
import {
  calculateNonNullPercentage,
  getSafeguardingScoreFields,
  aggregateSafeguardingScore,
} from '../../utils/utils'
import UIDocumentPicker from '../../components/UI/UIDocumentPicker'
import UiSelect from '../../components/UI/UISelect'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UITextInput from '../../components/UI/UITextInput'
import {
  ErrorResponse,
  UploadResponse,
  UserSafeguardingRecordsData,
  UserTraningRecordsData,
  safeguardingRecords,
  trainingRecords,
} from '../../utils/types'
import { fileUpload } from '../../api/apiService'
import { toast } from 'react-toastify'
import {
  AddUserTrainingRecords,
  updateUserSafeguardingRecords,
  updateUserTrainingRecords,
} from '../../api/lead/scr'
import {
  createRecordFormDataInterface,
  trainingRecordsData,
  updateRecordFormDataInterface,
} from '../myscr-records/TrainingRecord'
import PdfViewer from '../../components/UI/PdfViewer'
import {
  Comment,
  getColumnDataByCategoryId,
  getSafeguardingColumnDataByCategoryId,
  SafeguardingRecor,
  TrainingRecor,
} from './utils'
import {
  createSafeguardingRecordFormDataInterface,
  safeguardingRecordsData,
} from '../candidates/myscr/SafeguardingRecords'
import { updateSafeguardingRecordFormDataInterface } from '../myscr-records/SafeGuardingRecords'
import {
  rejectSafeguardingDocument,
  safeguardingRecordComment,
} from '../../api/admin/scr'
import { getAllUsers } from '../../api/admin/settings'

type AnyObject = { [key: string]: any }
type AnyArray = any[]
type TrainingRecord = {
  id?: string
  userId: string
  trainingRecordCategoryId: string
  schoolId: string
  certificateNumber: string | null
  date: string | null
  reviewDate: string | null
  verifiedBy: string | null
  verificationDate: string | null
  riskAssessmentStatus: string | null
  duration: string | null
  certificate: string | null
}
function convertNullsToUndefined(
  obj: AnyObject | AnyArray,
  columnsToRemove?: string[]
): AnyObject | AnyArray | undefined {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
      if (!columnsToRemove?.includes(key)) {
        // Check if the key is not in the columns to remove
        acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
      }
      return acc
    }, {})
  } else {
    return obj === null ? undefined : obj
  }
}

const Safeguarding = ({
  data,
  isEdit,
  setIsEdit,
  scrRecordRefetch,
}: {
  data?: User
  isEdit: boolean
  setIsEdit: Dispatch<SetStateAction<boolean>>
  scrRecordRefetch?: () => void
}) => {
  const { data: categories, refetch: refetchCategories } = useQuery(
    'categories',
    () => getSafeguardingCategoriesForSCR()
  )

  const { data: AllUsers } = useQuery('users', () => getAllUsers())

  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [showButtons, setShowButtons] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)
  const [safeguardingRecords, setSafeguardingRecords] = useState<any>([])
  const [safeguardingRecordId, setSafeguardingRecordId] = useState('')
  const [commentsInputs, setCommentInputs] = useState<{
    [key: string]: string
  }>({})
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createSafeguardingRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateSafeguardingRecordFormDataInterface[]
  >([])

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (data?.safeguardingRecords !== undefined) {
      const mergedArray = categories?.data?.map((category) => {
        const matchingRecords =
          data?.safeguardingRecords?.filter(
            (record: any) => record.safeguardingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            safeguardingRecordCategoryId: category.id,
            isExpiryDate: category.expiryDate,
            isIssueDate: category.issueDate,
            isRiskAssessment: category.riskAssessment,
          }
        } else {
          let obj = {}
          matchingRecords?.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record?.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...updatedRecord,
              title: category.title || undefined,
              isExpiryDate: category.expiryDate,
              isIssueDate: category.issueDate,
              isRiskAssessment: category.riskAssessment,
            }
          })
          return obj
        }
      })
      if (mergedArray) setSafeguardingRecords(mergedArray)
    }
  }, [data, categories])

  useEffect(() => {}, [data])

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: safeguardingRecordsData
  ) => {
    if (Object.keys(item)?.length > 3) {
      setSafeguardingRecords((prev: any) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record: any) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev?.map((record: any, index: number) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev?.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'certificate' || undefined) {
        setSafeguardingRecords((prev: any) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record: any) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev?.map((record: any, index: number) => {
              if (index === existingItemIndex) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.safeguardingRecordCategoryId ===
                item.safeguardingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: safeguardingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse

        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('document', response?.url, item)
      } catch (error) {
        handleChange('document', item?.document ? item?.document : '', item)
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  useEffect(() => {
    if (safeguardingRecords) {
      const updatedRecords = safeguardingRecords.map(
        (record: { [x: string]: string; documentUrl: string }) => {
          const {
            documentUrl,
            riskDocumentUrl,
            safeguardId,
            comments,
            firstName,
            ...rest
          } = record // Destructure to omit documentUrl
          return rest
        }
      )
      setUpdateRecordFormData(updatedRecords)
    }
  }, [safeguardingRecords])

  const updateTrainingRecodrdsData = async (): Promise<void> => {
    try {
      setIsUpdateLoading(true)

      const convertedValues = convertNullsToUndefined(updateRecordFormData, [
        'isExpiryDate',
        'isIssueDate',
        'isRiskAssessment',
        'id',
        'title',
      ])
      const bodyData = {
        safeguardingRecords: convertedValues,
      } as UserSafeguardingRecordsData
      const response = (await updateUserSafeguardingRecords(
        bodyData,
        data?.schoolId || '',
        data?.userId
      )) as {
        status?: string
        data: safeguardingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        scrRecordRefetch && scrRecordRefetch()
        setIsEdit(false)
        toast.success('Records Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const postComment = async (
    safeguardId: string,
    comment: string
  ): Promise<void> => {
    try {
      const response = (await safeguardingRecordComment(
        data?.userId as string,
        safeguardId,
        data?.schoolId as string,
        comment
      )) as {
        status?: string
        data: safeguardingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        scrRecordRefetch && scrRecordRefetch()
        setIsEdit(false)
        toast.success(`Comment Sent.`, {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const verifyDoc = async (status: string): Promise<void> => {
    try {
      const response = (await rejectSafeguardingDocument(
        safeguardingRecordId,
        status
      )) as {
        status?: string
        data: safeguardingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        scrRecordRefetch && scrRecordRefetch()
        setShowButtons(false)
        setIsEdit(false)
        toast.success(
          `Document ${status.toLowerCase().replace(/\b./g, function (a) {
            return a.toUpperCase()
          })}.`,
          {
            position: 'top-right',
          }
        )
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleRiskFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: safeguardingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse

        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('riskDocument', response?.url, item)
      } catch (error) {
        handleChange(
          'riskDocument',
          item?.riskDocument ? item?.riskDocument : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }

  // Overall scorecard, shared with the candidate view via utils so the same
  // record scores identically here and on My SCR (Behaviour B).
  const scorecard = aggregateSafeguardingScore(
    categories?.data,
    safeguardingRecords
  )

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        // scrollbarWidth: 'none',
        scrollbarWidth: 'none',
      }}
    >
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            // height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {isEdit ? (
            <>
              {safeguardingRecords?.map((item: any, index: number) => {
                return (
                  <Accordion key={index} defaultActiveIndex={null}>
                    <AccordionItem
                      title={item?.title ? item?.title : ''}
                      isActive={false}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UiSelect
                              onChange={(e: string) => {
                                handleChange('documentType', e, item)
                              }}
                              value={
                                item?.documentType ? item?.documentType : ''
                              }
                              options={[
                                { value: 'Passport', label: 'Passport' },
                                {
                                  value: 'Driving License',
                                  label: 'Driving License',
                                },
                                {
                                  value: 'Birth Certificate',
                                  label: 'Birth Certificate',
                                },
                                {
                                  value: 'Certificate',
                                  label: 'Certificate',
                                },
                                {
                                  value: 'Other',
                                  label: 'Other',
                                },
                              ]}
                              title={'Document Type'}
                            />
                          </div>
                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'Document No'}
                              label={'Document No'}
                              iconName={''}
                              value={item?.documentNo ? item?.documentNo : ''}
                              onChange={(e) =>
                                handleChange('documentNo', e.target.value, item)
                              }
                            />
                          </div>
                        </div>

                        <UIDocumentPicker
                          id={item?.title ? item?.title : 'pickerInput'}
                          handleRemoveFile={() => {
                            handleChange('document', '', item)
                          }}
                          label={'Document'}
                          initialValue={item?.document ? item?.document : ''}
                          onChange={(e) =>
                            handleFileChange('document', e, item)
                          }
                          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                          labelClassName="custom-label-class"
                        />

                        <div className="flex w-full gap-4">
                          {item.isIssueDate && (
                            <div className="w-6/12  ">
                              <UIDatePickerv
                                placeholderText={'Not Specified'}
                                title={'Issue Date'}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleChange(
                                    'issueDate',
                                    e.target.value,
                                    item
                                  )
                                }}
                                value={
                                  item?.issueDate
                                    ? item?.issueDate.split('T')[0]
                                    : ''
                                }
                              />
                            </div>
                          )}
                          {item.isExpiryDate && (
                            <div className="w-6/12">
                              <UIDatePickerv
                                placeholderText={'Not Specified'}
                                title={'Expiry Date'}
                                value={
                                  item?.expiryDate
                                    ? item?.expiryDate.split('T')[0]
                                    : ''
                                }
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleChange(
                                    'expiryDate',
                                    e.target.value,
                                    item
                                  )
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UiSelect
                              options={
                                (
                                  AllUsers as {
                                    data: {
                                      data: {
                                        userId: string
                                        firstName: string
                                      }[]
                                    }
                                  }
                                )?.data?.data?.map((i) => ({
                                  value: i.userId,
                                  label: i.firstName,
                                })) || []
                              }
                              title={'Verified by'}
                              value={item?.verifiedBy ? item?.verifiedBy : ''}
                              onChange={(e) =>
                                handleChange('verifiedBy', e, item)
                              }
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Verification Date'}
                              value={
                                item?.verificationDate
                                  ? item?.verificationDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange(
                                  'verificationDate',
                                  e.target.value,
                                  item
                                )
                              }}
                            />
                          </div>
                        </div>
                        <>
                          <div className="flex w-full gap-4">
                            <div className="w-6/12  ">
                              <UiSelect
                                options={[
                                  { value: 'yes', label: 'YES' },
                                  { value: 'no', label: 'NO' },
                                ]}
                                title={'Risk Assessment Status'}
                                value={
                                  item?.riskAssessmentStatus
                                    ? item?.riskAssessmentStatus
                                    : ''
                                }
                                onChange={(e: string) => {
                                  handleChange('riskAssessmentStatus', e, item)
                                }}
                              />
                            </div>
                            {item.riskAssessmentStatus !== 'no' && (
                              <div className="w-6/12">
                                <UiSelect
                                  value={item?.duration}
                                  options={[
                                    {
                                      value: '12 Months',
                                      label: '12 Months',
                                    },
                                    { value: '9 Months', label: '9 Months' },
                                    { value: '6 Months', label: '6 Months' },
                                    { value: '3 Months', label: '3 Months' },
                                    { value: '0 Months', label: '0 Months' },
                                  ]}
                                  title={'Duration'}
                                  onChange={(e: string) => {
                                    handleChange('duration', e, item)
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {item.riskAssessmentStatus !== 'no' && (
                            <UIDocumentPicker
                              id={item?.title ? item?.title : 'pickerInput'}
                              handleRemoveFile={() => {
                                handleChange('riskDocument', '', item)
                              }}
                              label={'Risk Assesment Document'}
                              initialValue={
                                item?.riskDocument ? item?.riskDocument : ''
                              }
                              onChange={(e) =>
                                handleRiskFileChange('riskDocument', e, item)
                              }
                              accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                              labelClassName="custom-label-class"
                            />
                          )}
                        </>
                      </div>
                    </AccordionItem>
                  </Accordion>
                )
              })}
              <div className="w-[33%] mt-6">
                <UIButton
                  onClick={updateTrainingRecodrdsData}
                  loading={isUpdateLoading}
                  label="Update"
                />
              </div>
            </>
          ) : (
            <>
              {categories?.data?.map((item, index) => (
                <Accordion key={index} defaultActiveIndex={0}>
                  <AccordionItem title={item?.title} isActive={false}>
                    <div className="flex flex-col mt-2 my-4 px-2">
                      <div className="overflow-hidden rounded-[16px] w-full mb-[30px]">
                        <table className="rounded-[16px] overflow-hidden border w-full border-white">
                          <tbody>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Document Type
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getSafeguardingColumnDataByCategoryId(
                                  data!
                                    .safeguardingRecords as SafeguardingRecor[],
                                  item.id,
                                  'documentType'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Document Number
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getSafeguardingColumnDataByCategoryId(
                                  data!
                                    .safeguardingRecords as SafeguardingRecor[],
                                  item.id,
                                  'documentNo'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                External url
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {item?.referenceUrl}
                              </td>
                            </tr>
                            {item.issueDate && (
                              <tr className="bg-gray1">
                                {/* Example row */}
                                <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                  Issue Date
                                </td>
                                <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                  {
                                    (
                                      (getSafeguardingColumnDataByCategoryId(
                                        data!
                                          .safeguardingRecords as SafeguardingRecor[],
                                        item.id,
                                        'issueDate'
                                      )[0] || '') as string
                                    ).split('T')[0]
                                  }
                                </td>
                              </tr>
                            )}

                            {item.expiryDate && (
                              <tr className="bg-gray1">
                                {/* Example row */}
                                <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                  Expiry Date
                                </td>
                                <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                  {
                                    (
                                      (getSafeguardingColumnDataByCategoryId(
                                        data!
                                          .safeguardingRecords as SafeguardingRecor[],
                                        item.id,
                                        'expiryDate'
                                      )[0] || '') as string
                                    ).split('T')[0]
                                  }
                                </td>
                              </tr>
                            )}
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Verified By
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {getSafeguardingColumnDataByCategoryId(
                                  data!
                                    .safeguardingRecords as SafeguardingRecor[],
                                  item.id,
                                  'firstName'
                                )}
                              </td>
                            </tr>
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Verification Date
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                {
                                  (
                                    (getSafeguardingColumnDataByCategoryId(
                                      data!
                                        .safeguardingRecords as SafeguardingRecor[],
                                      item.id,
                                      'verificationDate'
                                    )[0] || '') as string
                                  ).split('T')[0]
                                }
                              </td>
                            </tr>
                            {item.riskAssessment && (
                              <>
                                <tr className="bg-gray1">
                                  {/* Example row */}
                                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                    Risk Assessment Status
                                  </td>
                                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                    {getSafeguardingColumnDataByCategoryId(
                                      data!
                                        .safeguardingRecords as SafeguardingRecor[],
                                      item.id,
                                      'riskAssessmentStatus'
                                    )}
                                  </td>
                                </tr>
                                <tr className="bg-gray1">
                                  {/* Example row */}
                                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                    Duration
                                  </td>
                                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                    {getSafeguardingColumnDataByCategoryId(
                                      data!
                                        .safeguardingRecords as SafeguardingRecor[],
                                      item.id,
                                      'duration'
                                    )}
                                  </td>
                                </tr>
                                <tr className="bg-gray1">
                                  {/* Example row */}
                                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                    Risk Document{' '}
                                  </td>
                                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                    <div
                                      onClick={() => {
                                        const url =
                                          getSafeguardingColumnDataByCategoryId(
                                            data!
                                              .safeguardingRecords as SafeguardingRecor[],
                                            item.id,
                                            'riskDocumentUrl'
                                          ) || null

                                        if (!url[0]) return

                                        if (
                                          (url as unknown as string) ==
                                          'IN PROGRESS'
                                        ) {
                                          return toast.warning(
                                            'Scanning the file, please check again in a few seconds.',
                                            {
                                              position: 'top-right',
                                            }
                                          )
                                        }
                                        if (
                                          (url as unknown as string) ==
                                          'NoSuchKey'
                                        ) {
                                          return toast.warning(
                                            'File is removed',
                                            {
                                              position: 'top-right',
                                            }
                                          )
                                        }

                                        setSafeguardingRecordId(
                                          getSafeguardingColumnDataByCategoryId(
                                            data!
                                              .safeguardingRecords as SafeguardingRecor[],
                                            item.id,
                                            'safeguardId'
                                          ).toString()
                                        )
                                        setPdfUrl(`${url}`)
                                        if (
                                          getSafeguardingColumnDataByCategoryId(
                                            data!
                                              .safeguardingRecords as SafeguardingRecor[],
                                            item.id,
                                            'document_verification_status'
                                          )[0] == 'pending'
                                        ) {
                                          setShowButtons(true)
                                        } else {
                                          setShowButtons(false)
                                        }
                                        setIsOpenPdfViewer(true)
                                      }}
                                      key={index}
                                      className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                                    >
                                      <Icon
                                        name="IconFile"
                                        width={16}
                                        height={16}
                                        strokeWidth={2}
                                        stroke={'#02698C'}
                                      />
                                      <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                        {getSafeguardingColumnDataByCategoryId(
                                          data!
                                            .safeguardingRecords as SafeguardingRecor[],
                                          item.id,
                                          'riskDocument'
                                        )[0] == null
                                          ? 'No File'
                                          : lastStr(
                                              getSafeguardingColumnDataByCategoryId(
                                                data!
                                                  .safeguardingRecords as SafeguardingRecor[],
                                                item.id,
                                                'riskDocument'
                                              )[0] as string
                                            )}
                                      </p>
                                      <Icon
                                        name="IconDownloadCloud"
                                        width={16}
                                        height={16}
                                        strokeWidth={1.5}
                                        stroke={'#67A5B9'}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                            <tr className="bg-gray1">
                              {/* Example row */}
                              <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                Certificate
                              </td>
                              <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                <div
                                  onClick={() => {
                                    const url =
                                      getSafeguardingColumnDataByCategoryId(
                                        data!
                                          .safeguardingRecords as SafeguardingRecor[],
                                        item.id,
                                        'documentUrl'
                                      ) || null

                                    if (!url[0]) return

                                    if (
                                      (url as unknown as string) ==
                                      'IN PROGRESS'
                                    ) {
                                      return toast.warning(
                                        'Scanning the file, please check again in a few seconds.',
                                        {
                                          position: 'top-right',
                                        }
                                      )
                                    }
                                    if (
                                      (url as unknown as string) == 'NoSuchKey'
                                    ) {
                                      return toast.warning('File is removed', {
                                        position: 'top-right',
                                      })
                                    }

                                    setSafeguardingRecordId(
                                      getSafeguardingColumnDataByCategoryId(
                                        data!
                                          .safeguardingRecords as SafeguardingRecor[],
                                        item.id,
                                        'safeguardId'
                                      ).toString()
                                    )

                                    setPdfUrl(`${url}`)
                                    if (
                                      getSafeguardingColumnDataByCategoryId(
                                        data!
                                          .safeguardingRecords as SafeguardingRecor[],
                                        item.id,
                                        'document_verification_status'
                                      )[0] == 'pending'
                                    ) {
                                      setShowButtons(true)
                                    } else {
                                      setShowButtons(false)
                                    }
                                    setIsOpenPdfViewer(true)
                                  }}
                                  key={index}
                                  className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                                >
                                  <Icon
                                    name="IconFile"
                                    width={16}
                                    height={16}
                                    strokeWidth={2}
                                    stroke={'#02698C'}
                                  />
                                  <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                    {getSafeguardingColumnDataByCategoryId(
                                      data!
                                        .safeguardingRecords as SafeguardingRecor[],
                                      item.id,
                                      'document'
                                    )[0] == null
                                      ? 'No File'
                                      : lastStr(
                                          getSafeguardingColumnDataByCategoryId(
                                            data!
                                              .safeguardingRecords as SafeguardingRecor[],
                                            item.id,
                                            'document'
                                          )[0] as string
                                        )}
                                  </p>
                                  <Icon
                                    name="IconDownloadCloud"
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {(() => {
                          const id = getSafeguardingColumnDataByCategoryId(
                            data!.safeguardingRecords as SafeguardingRecor[],
                            item.id,
                            'safeguardId'
                          )[0] as string

                          if (!id) return <></>

                          return (
                            <>
                              <table className="mt-5 rounded-[16px] overflow-hidden border w-full border-white">
                                <tbody>
                                  <tr>
                                    <td>Comment:</td>
                                    <td className="px-4 text-text1 font-semibold w-[100%] text-[14px] h-[48px] py-2 border border-white">
                                      <UITextInput
                                        placeholder={'Write here...'}
                                        iconName=""
                                        value={(() => {
                                          const id =
                                            getSafeguardingColumnDataByCategoryId(
                                              data!
                                                .safeguardingRecords as SafeguardingRecor[],
                                              item.id,
                                              'safeguardId'
                                            )[0] as string
                                          return commentsInputs[id] || ''
                                        })()}
                                        onChange={(e) => {
                                          const id =
                                            getSafeguardingColumnDataByCategoryId(
                                              data!
                                                .safeguardingRecords as SafeguardingRecor[],
                                              item.id,
                                              'safeguardId'
                                            )[0] as string
                                          setCommentInputs((pri) => ({
                                            ...pri,
                                            [id]: e.target.value,
                                          }))
                                        }}
                                      />
                                    </td>
                                    <td className="w-[11px] self-baseline">
                                      <UIButton
                                        onClick={() => {
                                          const id =
                                            getSafeguardingColumnDataByCategoryId(
                                              data!
                                                .safeguardingRecords as SafeguardingRecor[],
                                              item.id,
                                              'safeguardId'
                                            )[0] as string
                                          if (commentsInputs[id]) {
                                            postComment(id, commentsInputs[id])
                                            setCommentInputs((pri) => ({
                                              ...pri,
                                              [id]: '',
                                            }))
                                          }
                                        }}
                                        loading={false}
                                        secondary
                                        label="Commit"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              {/*// @ts-expect-error saas */}
                              {data.safeguardingRecords.find(
                                (record) =>
                                  record.safeguardingRecordCategoryId ===
                                  item.id
                                // @ts-expect-error temp
                              )?.comments.length > 0 && (
                                <h3 className="mt-2 p-1">Comments:</h3>
                              )}
                              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                                <tbody>
                                  {// @ts-expect-error temp
                                  data.safeguardingRecords
                                    .find(
                                      (record) =>
                                        record.safeguardingRecordCategoryId ===
                                        item.id
                                    )
                                    // @ts-expect-error temp
                                    ?.comments.slice()
                                    .reverse()
                                    .map((comment: Comment) => {
                                      return (
                                        <tr
                                          className="bg-gray1"
                                          key={comment.commentId}
                                        >
                                          {/* Example row */}
                                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                            Created By : {comment.firstName}
                                          </td>
                                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                                            {comment.comment}
                                          </td>
                                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                                            Created At:{' '}
                                            {
                                              (
                                                comment['comments.createdAt'] ||
                                                ''
                                              ).split('T')[0]
                                            }
                                          </td>
                                        </tr>
                                      )
                                    })}
                                </tbody>
                              </table>
                            </>
                          )
                        })()}
                      </div>
                    </div>
                  </AccordionItem>
                </Accordion>
              ))}
            </>
          )}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm font-semibold text-bluishGreen leading-6'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={scorecard.percentage}
                    text={`${scorecard.percentage}%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: scorecard.color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="w-full bg-white flex flex-col gap-4 my-4 px-4 py-4 rounded-xl">
                  {categories?.data?.map((item, index) => {
                    const fieldsToCheck = getSafeguardingScoreFields(
                      item,
                      safeguardingRecords?.[index]
                    )

                    return (
                      <div key={index} className="">
                        <div className="">
                          <UIStaightlineProressBar
                            percentage={
                              calculateNonNullPercentage(fieldsToCheck)
                                .percentage
                            }
                            label={item?.title}
                            stroke={
                              calculateNonNullPercentage(fieldsToCheck).color
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        showButtons={showButtons}
        url={pdfUrl}
        title="PDF Viewer"
        onAccept={() => verifyDoc('accepted')}
        onReject={() => verifyDoc('rejected')}
      />
    </div>
  )
}

export default Safeguarding
